import refs from '../refsLite'
import { setDoc } from 'firebase/firestore/lite'

export async function saveUserData(uid, userDataInstance) {
  await setDoc(refs.userData(uid), userDataInstance)
}
